module.exports = __webpack_public_path__ + "static/media/personal-accidents-insurance-card-img.31877032.png";